import DataQuery from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';
import { jsonToInputParams } from 'library/util/graph';

const getRecommendedOutcomes = async ({
  user,
  sort_by = 'created_at',
  order = 'asc',
  by_outcome_name,
  by_user_outcome_status,
}) => {
  const params = user
    ? {
        uuid: user.uuid,
        sort_by: sort_by,
        order: order,
        by_outcome_name: by_outcome_name,
        by_user_outcome_status: by_user_outcome_status,
      }
    : {};
  return await DataQuery(
    `
  {
    all_recommendations(${jsonToInputParams(params)}) {
      results {
        id
        accepted_at
        updated_at
        created_at
        archived:archived_at
        user_referrer {
          id
          first_name
        }
        user {
          id
        }
        due_date
        outcome {
          id
          name
          description
          color
          goals {
            id
            name
            description
            icon {
              id
              category
              action
              filename
            }
            steps {
              id
              name
              description
            }
          }
        }
      }
    }
  }
  `
  );
};

const getRecommendedOutcomesParseQuery = (data) => ({
  outcomes: resolve(data, 'all_recommendations/results', []),
});

export { getRecommendedOutcomes, getRecommendedOutcomesParseQuery };
